class Snow {
    constructor() {
        this.amount = 100;
        this.speedX = 6;
        this.speedY = 1.5;
        this.animationDelay = 33.333;
        this.animationInterval = null;
        this.snowFlakes = [];
        this.direction = 0;
        this.windSteps = 0;
        this.wind = 0;
    }

    init() {
        let html = $("html");
        for (let i = 0; i < this.amount; i++) {
            let snowflake = $("<snow>⬤</snow>");
            snowflake[0].px = (20 + (Math.random() * (document.body.scrollWidth - 40)));
            snowflake[0].py = Math.random() * (document.body.scrollHeight - 40);
            snowflake[0].speedX = this.speedX * Math.random();
            snowflake[0].speedY = (this.speedY * Math.random()) + 0.2;
            snowflake[0].opacity = 0.5 + (0.5 * Math.random());
            snowflake[0].style.fontSize = ((5 * Math.random()) + 3) + "px";
            this.snowFlakes.push(snowflake[0]);
            html.append(snowflake);
        }
        this.start();
    }

    start() {
        this.animationInterval = setInterval(() => {
            if (app.config.isFocused) {
                this.update();
            }
        }, this.animationDelay);
    }

    update() {
        if (this.windSteps-- < 0) {
            this.windSteps = 10 + Math.round(2 * Math.random());
            if (this.direction === 0) {
                this.direction = 1;
            } else {
                this.direction = 0;
            }
        }
        if (this.direction === 1) {
            this.wind += (Math.random() / (100 + (this.wind * 10)));
        } else {
            this.wind -= (Math.random() / (100 - (this.wind * 10)));
        }
        for (let i of this.snowFlakes) {
            i.px += i.speedX * this.wind;
            i.py += i.speedY * Math.random();
            if (i.px > (document.body.scrollWidth - 40) || i.px <= 30 || i.py > (document.body.scrollHeight - 30)) {
                if (i.opacity <= 0) {
                    this.reset(i);
                } else {
                    i.opacity -= 0.05;
                    i.style.opacity = i.opacity;
                    i.style.left = i.px + "px";
                    i.style.top = i.py + "px";
                }
            } else {
                i.style.left = i.px + "px";
                i.style.top = i.py + "px";
                i.style.opacity = i.opacity;
            }
        }
    }

    reset(i) {
        i.px = (20 + (Math.random() * (document.body.scrollWidth - 40)));
        i.py = -20;
        i.opacity = 0.5 + (0.5 * Math.random());
    }
}